import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 dialog-footer text-center" }

import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {computed} from "vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";


const __default__ = {
    name: "CabinetClientDialogFooter"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


let usernames = OperatorAccountStore.cabinetClientDialog.value.usernames;
let username = computed(() => OperatorAccountStore.cabinetClientDialog.value.username);
let userdata = computed(() => ClientUserdataStore.getByUsername(username.value));

function changeUsername(username: string) {
    OperatorAccountStore.cabinetClientDialog.value.username = username;
}


let nextUsername = computed<string | null>(() => {
    if (usernameIndex.value > -1) {
        return usernames[usernameIndex.value + 1];
    }
    return null;
});

let prevUsername = computed<string | null>(() => {
    if (usernameIndex.value > -1) {
        return usernames[usernameIndex.value - 1];
    }
    return null;
});

let usernameIndex = computed(() => usernames.indexOf(username.value));


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(prevUsername) || _unref(nextUsername))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          disabled: !_unref(prevUsername),
          type: "primary",
          plain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeUsername(_unref(prevUsername))))
        }, {
          icon: _withCtx(() => [
            _createVNode(FontAwesomeIcon, { icon: "arrow-left" })
          ]),
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "d-none d-md-inline-block ml-1" }, "Предыдущий", -1))
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_button, {
      tag: "a",
      disabled: !_unref(userdata)?.infoLink,
      href: _unref(userdata)?.infoLink,
      target: "_blank",
      type: "primary",
      plain: ""
    }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createTextVNode(" Внешняя ссылка ", -1)
      ]))]),
      _: 1
    }, 8, ["disabled", "href"]),
    (_unref(prevUsername) || _unref(nextUsername))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          disabled: !_unref(nextUsername),
          type: "primary",
          plain: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeUsername(_unref(nextUsername))))
        }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "d-none d-md-inline-block mr-1" }, "Следующий", -1)),
            _createVNode(FontAwesomeIcon, { icon: "arrow-right" })
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})